module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/rectangleConversionS.56022f48.svg";